// extracted by mini-css-extract-plugin
module.exports = {"additionalText":"WATnK","error":"faCDb"};